// 动态验证码插件

import commonUtil from '@/util/common';

import './index.scss';

const appId = 'b2490b01f4064728719d9f83a70ce8b3';
declare global {
    interface Window {
        _dx: any;
    }
}
const options = {
    appId,
    style: 'embed',
    customLanguage: {
        smart_checking: '',
        pass_by_server: '无感验证成功'
    },
    customStyle: {
        slider: {
            normalBgColor: '#4595FB', // 滑块占位颜色，避免由于加载滑块图片慢导致闪烁现象。
            normalBgSrc:
                'https://cdn.dingxiang-inc.com/images/902/90238b80-fcef-4ed6-9b60-9383eae0fc46.png',
            hoverBgSrc:
                'https://cdn.dingxiang-inc.com/images/b98/b98947f2-d774-4704-8683-c99271d2bea0.png',
            focusBgSrc:
                'https://cdn.dingxiang-inc.com/images/240/2409c377-e15a-482f-966f-f475a5fcfbb9.png',
            loadingBgSrc:
                'https://cdn.dingxiang-inc.com/images/a9b/a9b724a5-93f0-4541-b755-d138a8de4f59.png',
            errorBgSrc:
                'https://cdn.dingxiang-inc.com/images/d21/d210ad20-5ddc-4c47-b834-700145a15d31.png',
            loadingGifSrc: 'https://s.ampmake.com/www/image/captcha/loading.gif'
        },
        bar: {
            hoverHideText: true,
            hoverBdColor: true,
            normalTextColor: '#97999B',
            normalBgColor: 'rgba(212,216,221,0.5)',
            normalBdColor: 'rgba(151,153,155,0.5)',
            successTextColor: '#4595FB',
            successBgColor: 'rgba(69,149,251,0.3)',
            successBdColor: 'rgb(69,149,251)',
            successIcon:
                'https://cdn.dingxiang-inc.com/images/c06/c0644d9c-96c3-4f52-8f5f-53fd06792355.png',
            failBgColor: 'rgba(255,0,0,0.3)',
            failBdColor: 'rgb(255,0,0)',
            slidingBdColor: '#4595FB',
            slidingBgColor: 'rgba(69,149,251,0.3)'
        },
        state: {
            passByServerTextColor: '#4595FB',
            passByServerIconSize: 16,
            passByServerIcon:
                'https://cdn.dingxiang-inc.com/images/c06/c0644d9c-96c3-4f52-8f5f-53fd06792355.png',
            passByServerBdColor: '#4595FB',
            loadingBgColor: '#F7F8F9',
            loadingIcon:
                'https://cdn.dingxiang-inc.com/files/13492/loading.gif',
            loadingIconSize: 40
        },
        content: {
            guideArrowIcon:
                'https://cdn.dingxiang-inc.com/images/4ac/4acd5ae4-46e2-4f88-b6c7-8d4f9e38d1ad.png'
        }
    },
    width: 300,
    _noLogo: true
};

class Security {
    public wrap: any;

    public initLoad: boolean;

    constructor() {
        this.wrap = null;
        this.initLoad = false;
        this.init();
    }

    public init() {
        const box = document.createElement('div');
        box.id = 'chj-security';
        document.body.appendChild(box);
    }

    public callback() {
        if (this.initLoad) {
            this.show();
        }
    }

    public render() {
        const that = this;
        const main = document.getElementById('chj-security');

        this.wrap = window['_dx'].Captcha(
            main,
            Object.assign(options, {
                style: 'popup',
                success(token: string) {
                    that.success(token);
                    that.hide();
                }
            })
        );
    }

    public show(callback?: any) {
        if (!window['_dx']) {
            this.initLoad = true;
            return;
        }
        if (this.wrap) {
            this.wrap.reload();
        } else {
            this.render();
        }
        this.wrap.show();
        if (typeof callback === 'function') {
            this.success = callback;
        }
    }

    public hide() {
        if (this.wrap) {
            this.wrap.hide();
        }
    }

    public success(token: string) {
        console.log(token);
    }
}

const url =
    'https://cdn.dingxiang-inc.com/ctu-group/captcha-js/1.3.42/index.js';
const security = new Security();

commonUtil.getScript(url, () => {
    security.callback();
});

export default security;
